import React, { useState, useEffect } from 'react'
import PublicAppHeader from '../PublicAppHeader'
import { LoadingSpinner } from '../Loaders'
import { APP_CONSTANTS, defaultBgImgId } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { ArticleLayoutCardComponent } from '../Tile/components/layoutCards/ArticleLayoutCard'
import { useNavigate } from 'react-router-dom'
import { getStringFromHTMLString } from 'src/mentor/helpers/utilityFunctions'
import { getFeatureList } from 'src/consumer/services/featureServices'

export default function ArticlesListingPage() {
  const [pageLoading, setPageLoading] = useState(false)
  const [articlesList, setArticlesList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)
  const navigate = useNavigate()

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList('article')
    if (resp?.status === 200) {
      setArticlesList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextArticlesPage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getFeatureList('article', nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setArticlesList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextArticlesPage,
    rootMargin: '0px 0px 700px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Explore Mental Health Articles | AUMHUM"
        description="Explore a variety of informative articles on mental health topics at AUMHUM, offering valuable insights and guidance."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['articles', 'understanding', 'healing']}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader config={{ showLinks: true }} />
          <PublicListingComponentVarOne
            heading="Explore Mental Health Articles"
            description="Explore a variety of informative articles on life at AUMHUM, offering valuable insights and guidance."
            actionText="Read"
            listItemsArray={articlesList}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
            CustomCardComponent={ArticleLayoutCardComponent}
            // customCardGetActionButtonLogic={(item) => ({
            //   text: 'Read',
            //   onClick: (item) => navigate(`${item.slug}`),
            // })}
            customCardProps={{
              getTo: (item) => `${item.slug}`,
            }}
            customCardGetMainImage={(item) =>
              item?.coverImage || item?.coverIcon || item?.blogBanner || defaultBgImgId
            }
            customCardGetSecondaryText={(item) => item.description}
            customCardGetTitleField={(item) => item?.title}
          />
        </>
      )}
    </>
  )
}
